export class Orientation {
    public static readonly Bottom = 'bottom';
    public static readonly BottomLeft = 'bottomLeft';
    public static readonly BottomRight = 'bottomRight';
    public static readonly Center = 'center';
    public static readonly Left = 'left';
    public static readonly Right = 'right';
    public static readonly Top = 'top';
    public static readonly TopLeft = 'topLeft';
    public static readonly TopRight = 'topRight';
}
